import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b50e98a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pay-detail_container"
}
const _hoisted_2 = { class: "detail_base-info card-white-6" }
const _hoisted_3 = { class: "detail_header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = {
  key: 0,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_6 = {
  key: 1,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_7 = { class: "card-white-6 hw_detail_table_container" }
const _hoisted_8 = {
  key: 0,
  class: "headline"
}
const _hoisted_9 = {
  key: 1,
  class: "headline"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  style: {"margin-right":"8px"}
}
const _hoisted_12 = {
  key: 1,
  style: {"margin-right":"8px"}
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("付款拆分")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("移除")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_WeEditableWarp = _resolveComponent("WeEditableWarp")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_table_action = _resolveComponent("table-action")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_FlowTimeLine = _resolveComponent("FlowTimeLine")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_we_select = _resolveComponent("we-select")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_page_detail_wrapper = _resolveComponent("page-detail-wrapper")!

  return (_openBlock(), _createBlock(_component_page_detail_wrapper, _mergeProps(_ctx.$attrs, {
    drop_down_menus: _ctx.get_drop_down_menus,
    collapsed: true,
    title: _ctx.showPay ? _ctx.pay.name + (_ctx.pay.is_deleted ? ' [DELETED]' : '') : ''
  }), {
    default: _withCtx(() => [
      (_ctx.showPay)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _withDirectives(_createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.pay.is_supply ? '付款' : '收款') + "信息", 1)
              ]),
              _createVNode(_component_a_form, null, {
                default: _withCtx(() => [
                  (_ctx.pay.is_purchase)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_a_row, {
                          gutter: 20,
                          type: "flex",
                          style: {"flex-wrap":"wrap"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "对方主体",
                                  name: "name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.company.name,
                                      edit: _ctx.editMode
                                    }, {
                                      text: _withCtx(() => [
                                        _createElementVNode("span", null, [
                                          _createVNode(_component_a_button, {
                                            type: "link",
                                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.jumpToCompany(_ctx.pay.company_id))),
                                            style: {"white-space":"pre-wrap"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.pay.company.name), 1)
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "我方主体",
                                  name: "we_company_name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.we_company_name,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.pay.contract_id)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 0,
                                  span: 24
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "合同",
                                      name: "name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.pay.contract.name,
                                          edit: _ctx.editMode
                                        }, {
                                          text: _withCtx(() => [
                                            _createElementVNode("span", null, [
                                              _createVNode(_component_a_button, {
                                                type: "link",
                                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.jumpToContract(_ctx.pay.contract))),
                                                style: {"white-space":"pre-wrap"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.pay.contract.name), 1)
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["value", "edit"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "属性",
                                  name: "category_name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.category_name,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "Team",
                                  name: "rd_team_name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.rd_team_name,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "创建人",
                                  name: "rd_owner_name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.rd_owner_name,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "创建时间",
                                  name: "create_time"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.create_time,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_divider, { style: {"margin":"5px 0"} }),
                        _createVNode(_component_a_row, {
                          gutter: 20,
                          type: "flex",
                          style: {"flex-wrap":"wrap"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "币种",
                                  name: "currency_name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.currency_name,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "金额",
                                  name: "pay_money"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.formatMoneyByRound(_ctx.pay.pay_money),
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: _ctx.isPurchase ? '一类付款类型' : '分类',
                                  name: "cat1_name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.cat1_name,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: _ctx.isPurchase ? '二类付款类型' : '分类明细',
                                  name: "cat2_name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.cat2_name,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            (_ctx.isPurchase)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 0,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "三类付款类型",
                                      name: "cat3_name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.pay.cat3_name,
                                          edit: _ctx.editMode
                                        }, null, 8, ["value", "edit"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "付款方式",
                                  name: "pay_method_name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.pay_method_name,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "手续费承担方",
                                  name: "rd_pay_fee_type_name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.rd_pay_fee_type_name,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "计划付款日期",
                                  name: "plan_pay_time"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.plan_pay_time,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "实际付款日期",
                                  name: "pay_time"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.pay_time,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_divider, { style: {"margin":"5px 0"} }),
                        _createVNode(_component_a_row, {
                          gutter: 20,
                          type: "flex",
                          style: {"flex-wrap":"wrap"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "银行名称",
                                  name: "bf_bank"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.bank.bf_bank,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "银行账号",
                                  name: "bf_account_number"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.bank.bf_account_number,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.isOversea)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 0,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "Swift Code",
                                      name: "bf_swift_code"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.pay.bank.bf_swift_code,
                                          edit: _ctx.editMode
                                        }, null, 8, ["value", "edit"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.isOversea)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 1,
                                  span: 18
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "银行地址",
                                      name: "bf_bank_address"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.pay.bank.bf_bank_address,
                                          edit: _ctx.editMode
                                        }, null, 8, ["value", "edit"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_a_row, {
                          gutter: 20,
                          type: "flex",
                          style: {"flex-wrap":"wrap"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "对方主体",
                                  name: "name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.company.name,
                                      edit: _ctx.editMode
                                    }, {
                                      text: _withCtx(() => [
                                        _createElementVNode("span", null, [
                                          _createVNode(_component_a_button, {
                                            type: "link",
                                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.jumpToCompany(_ctx.pay.company_id))),
                                            style: {"white-space":"pre-wrap"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.pay.company.name), 1)
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "我方主体",
                                  name: "we_company_name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.we_company_name,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.pay.contract_id)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 0,
                                  span: 12
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "合同",
                                      name: "name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.pay.contract.name,
                                          edit: _ctx.editMode
                                        }, {
                                          text: _withCtx(() => [
                                            _createElementVNode("span", null, [
                                              _createVNode(_component_a_button, {
                                                type: "link",
                                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.jumpToContract(_ctx.pay.contract))),
                                                style: {"white-space":"pre-wrap"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.pay.contract.name), 1)
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["value", "edit"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "属性",
                                  name: "category_name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.category_name,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "Team",
                                  name: "rd_team_name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.rd_team_name,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_divider, { style: {"margin":"5px 0"} }),
                        _createVNode(_component_a_row, {
                          gutter: 20,
                          type: "flex",
                          style: {"flex-wrap":"wrap"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "币种",
                                  name: "currency_name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.currency_name,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "金额",
                                  name: "pay_money"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.formatMoneyByRound(_ctx.pay.pay_money),
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.pay.is_demand && !_ctx.pay.is_virtual)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 0,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "银行手续费",
                                      name: "fee_money"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.pay.fee_money,
                                          edit: _ctx.editMode
                                        }, null, 8, ["value", "edit"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (!_ctx.isDirect)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 1,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "未核销金额",
                                      name: "unlinked_money"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.formatMoneyByRound(_ctx.pay.unlinked_money),
                                          edit: _ctx.editMode
                                        }, null, 8, ["value", "edit"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, {
                          gutter: 20,
                          type: "flex",
                          style: {"flex-wrap":"wrap"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "创建时间",
                                  name: "create_time"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.pay.create_time,
                                      edit: _ctx.editMode
                                    }, null, 8, ["value", "edit"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.pay.is_demand)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 0,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "收款日期",
                                      name: "pay_time"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.pay.pay_time,
                                          edit: _ctx.editMode
                                        }, null, 8, ["value", "edit"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.pay.is_supply)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 1,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "计划付款日期",
                                      name: "plan_pay_time"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.pay.plan_pay_time,
                                          edit: _ctx.editMode
                                        }, null, 8, ["value", "edit"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.pay.is_supply)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 2,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "实际付款日期",
                                      name: "pay_time"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.pay.pay_time,
                                          edit: _ctx.editMode
                                        }, null, 8, ["value", "edit"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.pay.is_prepay)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 3,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "发票号",
                                      name: "invoice_number"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.pay.invoice_number,
                                          edit: _ctx.editMode
                                        }, null, 8, ["value", "edit"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        (_ctx.pay.is_supply)
                          ? (_openBlock(), _createBlock(_component_a_row, {
                              key: 0,
                              gutter: 20,
                              type: "flex",
                              style: {"flex-wrap":"wrap"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "付款方式",
                                      name: "pay_method_name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.pay.pay_method_name,
                                          edit: _ctx.editMode
                                        }, null, 8, ["value", "edit"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (!_ctx.isDirect)
                                  ? (_openBlock(), _createBlock(_component_a_col, {
                                      key: 0,
                                      span: 6
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, {
                                          label: "付款类型",
                                          name: "rd_pay_category_name"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_WeEditableWarp, {
                                              value: _ctx.pay.rd_pay_category_name,
                                              edit: _ctx.editMode
                                            }, null, 8, ["value", "edit"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_a_col, {
                                      key: 1,
                                      span: 6
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, {
                                          label: "付款类型",
                                          name: "cat2_name"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_WeEditableWarp, {
                                              value: 
                      _ctx.pay.cat1_name + '-' + _ctx.pay.cat2_name + (!_ctx.isEmptyData(_ctx.pay.cat3_name) ? '-' + _ctx.pay.cat3_name : '')
                    ,
                                              edit: _ctx.editMode
                                            }, null, 8, ["value", "edit"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })),
                                _createVNode(_component_a_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "手续费承担方",
                                      name: "rd_pay_fee_type_name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.pay.rd_pay_fee_type_name,
                                          edit: _ctx.editMode
                                        }, null, 8, ["value", "edit"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.pay.is_supply)
                          ? (_openBlock(), _createBlock(_component_a_divider, {
                              key: 1,
                              style: {"margin":"5px 0"}
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.pay.is_supply)
                          ? (_openBlock(), _createBlock(_component_a_row, {
                              key: 2,
                              gutter: 20,
                              type: "flex",
                              style: {"flex-wrap":"wrap"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 12 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "银行名称",
                                      name: "bf_bank"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.pay.bank.bf_bank,
                                          edit: _ctx.editMode
                                        }, null, 8, ["value", "edit"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_col, { span: 12 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "银行账户",
                                      name: "bf_account_number"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.pay.bank.bf_account_number,
                                          edit: _ctx.editMode
                                        }, null, 8, ["value", "edit"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (_ctx.isOversea)
                                  ? (_openBlock(), _createBlock(_component_a_col, {
                                      key: 0,
                                      span: 6
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, {
                                          label: "Swift Code",
                                          name: "bf_swift_code"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_WeEditableWarp, {
                                              value: _ctx.pay.bank.bf_swift_code,
                                              edit: _ctx.editMode
                                            }, null, 8, ["value", "edit"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.isOversea)
                                  ? (_openBlock(), _createBlock(_component_a_col, {
                                      key: 1,
                                      span: 18
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, {
                                          label: "银行地址",
                                          name: "bf_bank_address"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_WeEditableWarp, {
                                              value: _ctx.pay.bank.bf_bank_address,
                                              edit: _ctx.editMode
                                            }, null, 8, ["value", "edit"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.isDirect)
                          ? (_openBlock(), _createBlock(_component_a_row, {
                              key: 3,
                              gutter: 20,
                              type: "flex",
                              style: {"flex-wrap":"wrap"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "付款原由",
                                      name: "note"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.pay.note,
                                          edit: _ctx.editMode
                                        }, null, 8, ["value", "edit"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ], 64)),
                  (_ctx.pay.peer_pay_id || _ctx.pay.related_pay_id)
                    ? (_openBlock(), _createBlock(_component_a_row, {
                        key: 2,
                        gutter: 20,
                        type: "flex",
                        style: {"flex-wrap":"wrap"}
                      }, {
                        default: _withCtx(() => [
                          (_ctx.pay.peer_pay_id)
                            ? (_openBlock(), _createBlock(_component_a_col, {
                                key: 0,
                                span: 24
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "抵扣关联收付款",
                                    name: "peer_pay_name"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.pay.peer_pay_name,
                                        edit: false
                                      }, {
                                        text: _withCtx(() => [
                                          _createElementVNode("span", null, [
                                            _createVNode(_component_a_button, {
                                              type: "link",
                                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.jumpToPay({ id: _ctx.pay.peer_pay_id }, true)))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.pay.peer_pay_name), 1)
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.pay.related_pay_id)
                            ? (_openBlock(), _createBlock(_component_a_col, {
                                key: 1,
                                span: 24
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { label: "内部关联收付款" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.pay.rd_related_pay_name,
                                        edit: false
                                      }, {
                                        text: _withCtx(() => [
                                          _createElementVNode("span", null, [
                                            _createVNode(_component_a_button, {
                                              type: "link",
                                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.jumpToPay({ id: _ctx.pay.related_pay_id })))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.pay.rd_related_pay_name), 1)
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ], 512), [
              [_vShow, _ctx.showPay]
            ]),
            (!_ctx.isDirect)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_we_table, _mergeProps(_ctx.configLinkedBillList, { "data-source": _ctx.showLinkedBillList }), _createSlots({
                    name: _withCtx(({ text, record }) => [
                      _createVNode(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (_ctx.jumpToBill(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(text), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    rd_state_name: _withCtx(({ text, record }) => [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ color: record.rd_state_color })
                      }, _toDisplayString(text), 5)
                    ]),
                    invoice_linked_amount: _withCtx(({ text, record }) => [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ color: record.color })
                      }, _toDisplayString(text), 5)
                    ]),
                    _: 2
                  }, [
                    (_ctx.canBillAction)
                      ? {
                          name: "action",
                          fn: _withCtx(({ record, column }) => [
                            _createVNode(_component_table_action, {
                              actions: _ctx.handleActions(record, column)
                            }, null, 8, ["actions"])
                          ])
                        }
                      : undefined
                  ]), 1040, ["data-source"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isPurchase && !_ctx.isProd)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_we_table, _mergeProps(_ctx.showSplitPayConfig, { "data-source": _ctx.showSplitPay }), null, 16, ["data-source"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.pay.flow_id)
                ? (_openBlock(), _createBlock(_component_FlowTimeLine, {
                    key: 0,
                    flow: _ctx.pay.flow,
                    onOnCatchFlag: _ctx.catchFlowFlag,
                    onOnUpdate: _ctx.afterEditPay
                  }, null, 8, ["flow", "onOnCatchFlag", "onOnUpdate"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_modal, {
        visible: _ctx.linkBillDialog,
        "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.linkBillDialog) = $event)),
        width: "1000px",
        centered: ""
      }, {
        title: _withCtx(() => [
          (_ctx.isSupply)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Edit & Link"))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, "Link Bill"))
        ]),
        footer: _withCtx(() => [
          (_ctx.isLinkingPayment)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, " 所有关联金额: " + _toDisplayString(_ctx.formatMoneyByRound(_ctx.linkBillAllLinked)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_12, "未关联金额: " + _toDisplayString(_ctx.formatMoneyByRound(_ctx.linkBillUnlinked)), 1)),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.linkBillDialog = false))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.linkBillForPay
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          (_ctx.linkBillList)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_a_form, { ref: "linkForm" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_table, {
                      dataSource: _ctx.linkBillList,
                      columns: _ctx.linkBillListColumns,
                      pagination: false,
                      rowKey: 
              (_record, index) => {
                return index;
              }
            ,
                      "row-selection": {
              selectedRowKeys: _ctx.BillSelectedRowKeys,
              onChange: _ctx.linkBillCheckAllChange,
              onSelect: _ctx.linkBillChange,
              getCheckboxProps: _ctx.getCheckboxProps,
            }
                    }, {
                      link_money: _withCtx(({ record, index }) => [
                        _createVNode(_component_a_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.linkBillList[index].link.link_money,
                              "onUpdate:value": ($event: any) => ((_ctx.linkBillList[index].link.link_money) = $event),
                              onChange: ($event: any) => (_ctx.linkMoneyChanged(record)),
                              disabled: !record.is_checked || record.pay_money_done
                            }, {
                              suffix: _withCtx(() => [
                                _createVNode(_component_svg_icon, {
                                  "icon-name": "TagsOutlined",
                                  onClick: ($event: any) => (_ctx.autoLinkBill(record))
                                }, null, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1032, ["value", "onUpdate:value", "onChange", "disabled"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }, 8, ["dataSource", "columns", "rowKey", "row-selection"])
                  ]),
                  _: 1
                }, 512)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_a_modal, {
        visible: _ctx.splitPayDialog,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.splitPayDialog) = $event)),
        width: "1000px",
        centered: ""
      }, {
        title: _withCtx(() => [
          _hoisted_15
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            style: {"float":"left"},
            disabled: _ctx.add_split_disabled,
            onClick: _ctx.addCol
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.splitPayDialog = false))
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.saveSplitPay
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_table, {
            dataSource: _ctx.splitPayItems,
            columns: _ctx.splitPayColoums,
            pagination: false
          }, {
            group_id: _withCtx(({ index }) => [
              _createVNode(_component_we_select, {
                value: _ctx.splitPayItems[index].group_id,
                "onUpdate:value": ($event: any) => ((_ctx.splitPayItems[index].group_id) = $event),
                placeholder: "请选择Group",
                style: {"width":"100%"},
                options: _ctx.can_use_group_items,
                onChange: ($event: any) => (_ctx.groupChange(index))
              }, null, 8, ["value", "onUpdate:value", "options", "onChange"])
            ]),
            bu_id: _withCtx(({ index }) => [
              _createVNode(_component_we_select, {
                value: _ctx.splitPayItems[index].bu_id,
                "onUpdate:value": ($event: any) => ((_ctx.splitPayItems[index].bu_id) = $event),
                placeholder: "请选择",
                style: {"width":"100%"},
                options: _ctx.splitPayItems[index].bu_items || [],
                disabled: !_ctx.splitPayItems[index].group_id
              }, null, 8, ["value", "onUpdate:value", "options", "disabled"])
            ]),
            team_id: _withCtx(({ index }) => [
              _createVNode(_component_we_select, {
                value: _ctx.splitPayItems[index].team_id,
                "onUpdate:value": ($event: any) => ((_ctx.splitPayItems[index].team_id) = $event),
                placeholder: "请选择",
                style: {"width":"100%"},
                options: _ctx.splitPayItems[index].team_items || [],
                disabled: !_ctx.splitPayItems[index].group_id
              }, null, 8, ["value", "onUpdate:value", "options", "disabled"])
            ]),
            split_money: _withCtx(({ index }) => [
              _createVNode(_component_a_input_number, {
                style: {"width":"100%"},
                value: _ctx.splitPayItems[index].split_money,
                "onUpdate:value": ($event: any) => ((_ctx.splitPayItems[index].split_money) = $event),
                placeholder: "请输入金额",
                disabled: !_ctx.splitPayItems[index].group_id
              }, null, 8, ["value", "onUpdate:value", "disabled"])
            ]),
            splitAction: _withCtx(({ index }) => [
              (_ctx.splitPayItems.length > 1)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    onClick: ($event: any) => (_ctx.deleteCol(index))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["dataSource", "columns"])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }, 16, ["drop_down_menus", "title"]))
}